import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { FaBookmark, FaPlus, FaRegBookmark } from 'react-icons/fa';
import { IoIosCheckmarkCircle } from 'react-icons/io'
import Popup from '../../component/Popup';
import NewCollection from './NewCollection';
const Collection = ({ collections, fetchCollections, image, addImageToCollection, collectionSets }) => {

  const [showCollections, setShowCollections] = useState(false)
  const [showNewCollection, setShowNewCollection] = useState(false)
  const [showOnClick, setShowOnClick] = useState(false)
  const addImageToCollectionById = async (e) => {
    e.preventDefault()
    addImageToCollection(image, e.target.id)
  }
  /*
  const deleteEventListenerAndUpdateState = (e) => {
    const target = e.target;
    if (e.target.parentElement && target.parentElement.id == `save-button-wrapper-${image._id}`) {
      return
    }

    if (e.target.parentElement && e.target.parentElement.parentElement && target.parentElement.parentElement.id == `save-button-wrapper-${image._id}`) {
      return
    }
    setShowOnClick(false)
    const designWrapper = document.getElementById('#design-recipe-images-wrapper')
    if (designWrapper) {
      designWrapper.removeEventListener('click', deleteEventListenerAndUpdateState)
    }
  }
  */
  const handleButtonClick = (e) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    if (!showOnClick) {
      //      const designWrapper = document.getElementById('#design-recipe-images-wrapper')
      // if (designWrapper) {
      //     designWrapper.addEventListener('click', deleteEventListenerAndUpdateState)
      //}
    }
    setShowOnClick(prev => (!prev))
  }

  //invisible group-hover:visible
  return <><div className="absolute bottom-4 right-4  " id={`save-button-wrapper-${image._id}`}>
    <div className={`font-semibold cursor-pointer text-[14px] border rounded-xl px-2 border-black ${Object.keys(collectionSets).map(id => collectionSets[id].has(image._id)).filter(t => t).length > 0 ? 'bg-red-600 hover:bg-red-700 text-white ' : ''}`}
      onMouseEnter={() => { setShowCollections(true); }}
      onMouseLeave={() => { setShowCollections(false); }}
      onClick={handleButtonClick}
    >{Object.keys(collectionSets).map(id => collectionSets[id].has(image._id)).filter(t => t).length > 0 ? 'Unsave' : 'Save'}
      {
        showCollections || showOnClick
          ? <div className='absolute  bg-slate-700/90 text-xs lg:text-sm py-3 left-1/2 -translate-x-20 lg:-translate-x-1/2 z-[1000] rounded ming-w-40 lg:min-w-80 cursor-auto max-h-[600px] overflow-y-auto text-white'>

            <div className='flex justify-between px-2 mb-2 py-1 '>
              <button className='ml-4 flex'
                onClick={(e) => {
                  setShowNewCollection(true)
                  e.preventDefault()
                  e.nativeEvent.stopImmediatePropagation()
                }}
              >
                <span className='mr-4'>Add New Collection</span>
                <FaPlus color='white' size={14} />
              </button>
            </div>
            {
              collections.map(c => <button id={c._id} onClick={(e) => {
                addImageToCollectionById(e)
                e.stopPropagation()
                e.nativeEvent.stopImmediatePropagation()
              }} className={`w-full py-2 text-left pl-2 ${collectionSets[c._id].has(image._id) ? 'bg-slate-600 hover:bg-slate-500 font-semibold' : 'bg-slate-700 hover:bg-slate-600'} flex justify-between pr-4`} >{c.collectionName} {collectionSets[c._id].has(image._id) ? <IoIosCheckmarkCircle size={20} /> : <div></div>}</button>)
            }
          </div>

          : null}
    </div>
  </div>
    <NewCollection show={showNewCollection} setIsPopUp={setShowNewCollection} image={image} addImageToCollection={addImageToCollection} fetchCollections={fetchCollections} collections={collections} />
  </>

}

export default Collection
